import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import physicianList from '../../util/physician-list'

const selectorStyle = {
    minWidth: '200px',
}

const GetAvailablePhysicians = (userList, partnerPhysicians, customer) => {
    const internalPhysiciansList = physicianList.createInternalPhysiciansList(userList, customer.treatingPhysicianId)
    const externalPhysiciansList = physicianList.createExternalPhysiciansList(userList, customer.treatingPhysicianId)
    const partnerPhysiciansList = physicianList.createPartnerPhysiciansList(partnerPhysicians)
    const physicians = [
        {
            label: "internal",
            options: internalPhysiciansList
        },
        {
            label: "external",
            options: externalPhysiciansList
        },
        {
            label: "partner",
            options: partnerPhysiciansList
        },
    ];

    const selectedObject = physicianList.findPhysician(internalPhysiciansList, customer.treatingPhysicianId)
        || physicianList.findPhysician(externalPhysiciansList, customer.treatingPhysicianId)
        || physicianList.findPhysician(partnerPhysiciansList, customer.partnerPhysicianId)

    return [physicians, selectedObject]
}

const PhysicianSelector = ({
      customer,
      physicianList,
      userList,
      reassignPhysician
}) => {
    const [options, selectedObject] = GetAvailablePhysicians(userList, physicianList, customer)

    const changeHandler = (data) => {
        reassignPhysician(data.value, data.physicianType)
    }

    return (
        <div className="qa-physician-selector" style={selectorStyle}>
            <Select
                className="basic-single"
                classNamePrefix="select"
                defaultValue={selectedObject}
                isSearchable={true}
                options={options}
                onChange={changeHandler}
            />
        </div>
    )
}

PhysicianSelector.propTypes = {
    customer: PropTypes.object.isRequired,
    physicianList: PropTypes.array.isRequired,
    userList: PropTypes.array.isRequired,
    reassignPhysician: PropTypes.func.isRequired,
}

export default PhysicianSelector



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/PhysicianSelector.js